module.exports = __webpack_public_path__ + "static/img/qiaohu2.1bfbfe0f.png";